import { Component, HostListener, OnInit } from '@angular/core';
import { WalletService } from '../../../../../services/wallet';

@Component({
  selector: 'app-e-commercemobile',
  templateUrl: './e-commercemobile.component.html',
  styleUrl: './e-commercemobile.component.scss'
})
export class ECommercemobileComponent implements OnInit {
  allData: any[] = [];
  filteredData: any[] = [];
  displayedData: any[] = [];

  contentReady = true;
  noData = false;
  isAr: boolean = localStorage.getItem('language') === 'ar';

  searchTerm = '';

  pageSize = 10;
  currentLimit = 10;
  isLoadingMore = false;
  private scrollLocked = false;

  addBalancePopUp = false;
  amount: any = null;
  note: any = '';
  userId: any = null;
  selectedUser: any = null;
  isSubmitting = false;

  constructor(private walletService: WalletService) {}

  ngOnInit(): void {
    this.loadAllUsers();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  loadAllUsers(): void {
    this.contentReady = true;

    this.walletService.getAllUsersWithWallets().subscribe({
      next: (res) => {
        this.allData = Array.isArray(res) ? res : res?.data || [];

        this.currentLimit = this.pageSize;
        this.applyFilter();

        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.allData = [];
        this.filteredData = [];
        this.displayedData = [];
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  onSearchChange(): void {
    this.currentLimit = this.pageSize;
    this.applyFilter();
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.currentLimit = this.pageSize;
    this.applyFilter();
  }

  applyFilter(): void {
    const term = this.searchTerm.trim().toLowerCase();

    if (!term) {
      this.filteredData = [...this.allData];
    } else {
      this.filteredData = this.allData.filter((user: any) => {
        const name = String(user?.name || '').toLowerCase();
        const username = String(user?.username || '').toLowerCase();
        const phone = String(user?.phone || '').toLowerCase();

        return (
          name.includes(term) ||
          username.includes(term) ||
          phone.includes(term)
        );
      });
    }

    this.noData = this.filteredData.length === 0;
    this.displayedData = this.filteredData.slice(0, this.currentLimit);
  }

  get hasMore(): boolean {
    return this.displayedData.length < this.filteredData.length;
  }

  loadMore(): void {
    if (!this.hasMore || this.isLoadingMore || this.scrollLocked || this.contentReady) {
      return;
    }

    this.isLoadingMore = true;
    this.scrollLocked = true;

    setTimeout(() => {
      this.currentLimit += this.pageSize;
      this.displayedData = this.filteredData.slice(0, this.currentLimit);

      this.isLoadingMore = false;
      this.scrollLocked = false;
    }, 250);
  }

  addCredit(user: any): void {
    this.selectedUser = user;
    this.userId = user?.id;
    this.amount = null;
    this.note = '';
    this.addBalancePopUp = true;
  }

  close(): void {
    this.addBalancePopUp = false;
    this.selectedUser = null;
    this.userId = null;
    this.amount = null;
    this.note = '';
    this.isSubmitting = false;
  }

  onSubmit(): void {
    if (!this.userId || !this.amount || this.amount <= 0 || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    this.walletService.addWalletBalance(this.userId, this.amount, this.note).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.close();
        this.loadAllUsers();
      },
      error: (err) => {
        console.error(err);
        this.isSubmitting = false;
      }
    });
  }

  getUserInitial(name: string): string {
    if (!name) {
      return '?';
    }

    return name.trim().charAt(0).toUpperCase();
  }

  trackByUser(index: number, item: any): any {
    return item?.id || index;
  }
}